module.exports = __webpack_public_path__ + "img/curv_19_a.6c4b78f6.jpg";